<div id="layout" class="theme-cyan">
  <app-project-leftmenu></app-project-leftmenu>

  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container-fluid">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Projects Dashboard</h5>
                  </div>
                  <small class="text-truncate text-muted">Total 15 (last update 1hr ago)</small>
                </div>
              </div>
            </div>

            <!-- page action  -->
            <div class="col-7 col-xl-8 text-end">
              <ul class="nav justify-content-end d-inline-flex">
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" title="Search this chat">
                    <i class="zmdi zmdi-search zmdi-hc-lg"></i>
                  </a>
                </li>
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a class="nav-link text-muted" [routerLink]="['/app-project-add']" href="javascript:void(0)">Add</a>
                </li>

                <!-- Mobile nav -->
                <li class="nav-item list-inline-item d-block d-sm-none px-3">
                  <div class="dropdown">
                    <a class="nav-link text-muted px-0" href="javascript:void(0)" data-bs-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item" href="javascript:void(0)">Add new</a>
                    </div>
                  </div>
                </li>
                <!-- Mobile nav -->
              </ul>
            </div>

          </div>

        </div>
      </div>

      <!-- Body: Search -->
      <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
        <div class="container-fluid py-2">

          <div class="row">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <div class="input-group-append">
                <span class="input-group-text text-muted"><small>0 / 0</small></span>
              </div>
              <div class="input-group-append dropdown" dropdown placement="bottom right">
                <button type="button" class="btn btn-secondary">Search</button>


                <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                  class="btn btn-secondary dropdown-toggle dropdown-toggle-split ml-1">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-basic">
                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container-fluid">

          <div class="row clearfix row-deck g-2 mb-5">
            <div class="col-lg-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <h6 class="card-title">Pending Tasks</h6>
                  <h4 class="number">245</h4>
                  <span>Measure How Fast... <a href="javascript:void(0)">More</a></span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <h6 class="card-title">New Message</h6>
                  <h4 class="number">12</h4>
                  <span>Measure How Fast... <a href="javascript:void(0)">More</a></span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <h6 class="card-title">Open Requests</h6>
                  <h4 class="number">19</h4>
                  <span>Measure How Fast... <a href="javascript:void(0)">More</a></span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <h6 class="card-title">Hours Spent</h6>
                  <h4 class="number">284</h4>
                  <span>Measure How Fast... <a href="javascript:void(0)">More</a></span>
                </div>
              </div>
            </div>
            <div class="col-xl-8 col-lg-7 col-md-12">
              <div class="card">
                <div class="card-header bg-transparent border-0 d-flex justify-content-between py-3">
                  <h6 class="card-title">Sales Analytics</h6>
                  <div class="dropdown d-inline-block" dropdown placement="bottom right">
                    <button type="button" class="btn btn-link dropdown-toggle" id="button-alignment" dropdownToggle
                      type="button" aria-controls="dropdown-alignment">
                      <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                    </button>
                    <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                      aria-labelledby="button-alignment">
                      <a class="dropdown-item" href="javascript: void(0)">Action</a>
                      <a class="dropdown-item" href="javascript: void(0)">Another action</a>
                      <a class="dropdown-item" href="javascript: void(0)">Something else here</a>
                      <div class="dropdown-divider"></div>
                      <a class="dropdown-item" href="javascript: void(0)">Separated link</a>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <app-area-chart></app-area-chart>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-5 col-md-6">
              <div class="card">
                <div class="card-header bg-transparent border-0 d-flex justify-content-between py-3">
                  <h6 class="card-title mb-0">Top Countries</h6>
                  <div class="dropdown d-inline-block" dropdown placement="bottom right">
                    <button type="button" class="btn btn-link dropdown-toggle" id="button-alignment" dropdownToggle
                      type="button" aria-controls="dropdown-alignment">
                      <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                    </button>
                    <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                      aria-labelledby="button-alignment">
                      <a class="dropdown-item" href="javascript: void(0)">Action</a>
                      <a class="dropdown-item" href="javascript: void(0)">Another action</a>
                      <a class="dropdown-item" href="javascript: void(0)">Something else here</a>
                      <div class="dropdown-divider"></div>
                      <a class="dropdown-item" href="javascript: void(0)">Separated link</a>
                    </div>
                  </div>
                </div>
                <table class="table table-hover mb-0">
                  <tbody>
                    <tr>
                      <td>
                        USA
                        <div class="progress mt-1" style="height: 2px;">
                          <div class="progress-bar" style="width: 78%"></div>
                        </div>
                      </td>
                      <td class="text-end"><span class="text-muted">$6425</span></td>
                    </tr>
                    <tr>
                      <td>
                        Poland
                        <div class="progress mt-1" style="height: 2px;">
                          <div class="progress-bar" style="width: 62%"></div>
                        </div>
                      </td>
                      <td class="text-end"><span class="text-muted">$5582</span></td>
                    </tr>
                    <tr>
                      <td>
                        Germany
                        <div class="progress mt-1" style="height: 2px;">
                          <div class="progress-bar" style="width: 48%"></div>
                        </div>
                      </td>
                      <td class="text-end"><span class="text-muted">$4587</span></td>
                    </tr>
                    <tr>
                      <td>
                        Russia
                        <div class="progress mt-1" style="height: 2px;">
                          <div class="progress-bar" style="width: 35%"></div>
                        </div>
                      </td>
                      <td class="text-end"><span class="text-muted">$2520</span></td>
                    </tr>
                    <tr>
                      <td>
                        Australia
                        <div class="progress mt-1" style="height: 2px;">
                          <div class="progress-bar" style="width: 30%"></div>
                        </div>
                      </td>
                      <td class="text-end"><span class="text-muted">$1899</span></td>
                    </tr>
                    <tr>
                      <td>
                        Great Britain
                        <div class="progress mt-1" style="height: 2px;">
                          <div class="progress-bar" style="width: 22%"></div>
                        </div>
                      </td>
                      <td class="text-end"><span class="text-muted">$1056</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-xl-4 col-lg-5 col-md-6">
              <div class="card">
                <div class="card-header bg-transparent border-0 d-flex justify-content-between py-3">
                  <h6 class="card-title">Project Statistics</h6>
                  <div class="card-options">
                    <a href="javascript:void(0)" class="card-options-collapse" data-toggle="card-collapse"><i
                        class="fe fe-chevron-up"></i></a>
                    <a href="javascript:void(0)" class="card-options-fullscreen" data-toggle="card-fullscreen"><i
                        class="fe fe-maximize"></i></a>
                    <a href="javascript:void(0)" class="card-options-remove" data-toggle="card-remove"><i
                        class="fe fe-x"></i></a>
                  </div>
                </div>
                <div class="card-body">
                  <div class="row text-center">
                    <div class="col-4 border-right py-2">
                      <label class="mb-0 small">Total Project</label>
                      <h4 class="font-weight-bold text-col-blue">42</h4>
                    </div>
                    <div class="col-4 border-right py-2">
                      <label class="mb-0 small">On Going</label>
                      <h4 class="font-weight-bold text-col-blue">23</h4>
                    </div>
                    <div class="col-4 py-2">
                      <label class="mb-0 small">Pending</label>
                      <h4 class="font-weight-bold text-col-blue">8</h4>
                    </div>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-striped table-vcenter mb-0">
                    <tbody>
                      <tr>
                        <td>
                          <div class="clearfix">
                            <div class="float-left"><strong>35%</strong></div>
                            <div class="float-right"><small class="text-muted">Design Team</small></div>
                          </div>
                          <div class="progress" style="height: 5px;">
                            <div class="progress-bar" role="progressbar" style="width: 35%" aria-valuenow="42"
                              aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="clearfix">
                            <div class="float-left"><strong>25%</strong></div>
                            <div class="float-right"><small class="text-muted">Developer Team</small></div>
                          </div>
                          <div class="progress" style="height: 5px;">
                            <div class="progress-bar" role="progressbar" style="width: 25%" aria-valuenow="0"
                              aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="clearfix">
                            <div class="float-left"><strong>15%</strong></div>
                            <div class="float-right"><small class="text-muted">Marketing</small></div>
                          </div>
                          <div class="progress" style="height: 5px;">
                            <div class="progress-bar" role="progressbar" style="width: 15%" aria-valuenow="36"
                              aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="clearfix">
                            <div class="float-left"><strong>20%</strong></div>
                            <div class="float-right"><small class="text-muted">Management</small></div>
                          </div>
                          <div class="progress" style="height: 5px;">
                            <div class="progress-bar" role="progressbar" style="width: 20%" aria-valuenow="6"
                              aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="clearfix">
                            <div class="float-left"><strong>11%</strong></div>
                            <div class="float-right"><small class="text-muted">Other</small></div>
                          </div>
                          <div class="progress" style="height: 5px;">
                            <div class="progress-bar" role="progressbar" style="width: 11%" aria-valuenow="6"
                              aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-xl-8 col-lg-7 col-md-12">
              <div class="card">
                <div class="card-header bg-transparent border-0 d-flex justify-content-between py-3">
                  <h6 class="card-title">Current Ticket Status</h6>
                  <div class="dropdown d-inline-block" dropdown placement="bottom right">
                    <button type="button" class="btn btn-link dropdown-toggle" id="button-alignment" dropdownToggle
                      type="button" aria-controls="dropdown-alignment">
                      <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                    </button>
                    <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                      aria-labelledby="button-alignment">
                      <a class="dropdown-item" href="javascript: void(0)">Action</a>
                      <a class="dropdown-item" href="javascript: void(0)">Another action</a>
                      <a class="dropdown-item" href="javascript: void(0)">Something else here</a>
                      <div class="dropdown-divider"></div>
                      <a class="dropdown-item" href="javascript: void(0)">Separated link</a>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <app-column-line-chart></app-column-line-chart>
                </div>
              </div>
            </div>
          </div> <!-- .row end -->

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>